import { render, staticRenderFns } from "./CandidatesAcceptTest.vue?vue&type=template&id=211aed06&lang=pug"
import script from "./CandidatesAcceptTest.vue?vue&type=script&lang=js"
export * from "./CandidatesAcceptTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports